export default "__VITE_ASSET__BiJssiXa__"